import React from "react";
import {Button} from "primereact/button";
import {buildCodexPrompt} from "../utils/build-codex-prompt";

export default function PromptPreview({brief, translate, onCopy}) {
    const text = buildCodexPrompt(brief, translate);
    return (
        <section className="pbb-preview-panel">
            <div className="pbb-panel-header">
                <div>
                    <h2>{translate("pbb-prompt-preview")}</h2>
                    <p>{translate("pbb-prompt-preview-description")}</p>
                </div>
                <Button icon="pi pi-copy" text rounded onClick={() => onCopy(text)} tooltip={translate("pbb-copy-prompt")}/>
            </div>
            <pre>{text}</pre>
        </section>
    );
}
